module.exports = __webpack_public_path__ + "img/career_activity1.f06f6272.jpeg";